import { BaseNomenclature } from "./baseNomenclature.model";

export class MeasurementUnit extends BaseNomenclature {
    constructor(){
        super();
        this.collection_name="measurement_units";
    }
}